export default __webpack_public_path__ + "static/media/logo-big.248d2cce.webp";